import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL + '/api' || 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export const expenseApi = {
    getCurrentUserId: () => {
        try {
            const userStr = localStorage.getItem('currentUser');
            if (!userStr) return 0;
            const user = JSON.parse(userStr);
            return user?.id || 0;
        } catch (e) {
            return 0;
        }
    },
    // Get user expenses with filters
    getUserExpenses: (userId, params) =>
        api.get(`/expenses/user/${userId}`, {
            params
        }),

    // Get expense by ID
    getExpenseById: (id) =>
        api.get(`/expenses/${id}`),

    // Create expense
    createExpense: (data) =>
        api.post('/expenses/create', data),

    // Update expense
    updateExpense: (id, data) =>
        api.put(`/expenses/${id}`, data),

    // Delete expense
    deleteExpense: (id) =>
        api.delete(`/expenses/${id}`),

    // Get monthly budget
    getMonthlyBudget: (userId) =>
        api.get(`/expenses/budget/${userId}`),

    // Set monthly budget
    setMonthlyBudget: (data) =>
        api.post('/expenses/budget', data),

    // Get statistics
    getStatistics: (userId) =>
        api.get(`/expenses/statistics/${userId}`),
};

export default expenseApi;